export default {
  CUSTOMER_DELETE: 'pending_deletes',
  WARRANTY_PENDING: 'pending_warranties',
  CMP_REGISTRATION_PENDING: 'pending_registrations',
  CMP_REGISTRATION_FOLLOW_UP: 'registration_follow_ups',
  PRODUCT_REPAIR_FOLLOW_UP: 'repair_follow_ups',
}